<script>
    import MenuIcon from 'vue-material-design-icons/Menu.vue'; 
    import CloseIcon from 'vue-material-design-icons/Close.vue'; 
    export default {
        components: {
            MenuIcon,
            CloseIcon
        },
        data() {
            return {
                menuOpen: false,
                user: "",
                uid: "",
                isAuthenticated: "",
                isAdmin: "",
                isApproved: "",
                userType: ""
            }
        },
        async mounted() {
          //user = await this.$store.getters.getCurrentUser()
          //let user = await this.$store.getters.getUserByUID("abc")
          console.log("mounted siteheader")
          this.isAuthenticated = await this.$store.getters.isAuthenticated
          this.isApproved = await this.$store.getters.isApproved
          this.uid = await this.$store.getters.currentUID
          
          this.isAdmin = await this.$store.getters.isAdmin
          this.user = await this.$store.getters.user
          if ( this.user ) {
            this.userType = this.user.userRec.type
          }
          
          // this.uid = await this.$store.getters.getCurrentUID
          // this.uid = await this.$store.getters.getCurrentUID
        },
        methods: {
            logout() {
                this.$store.commit('logout')
                this.menuOpen = false
                window.location = "/"
                //return this.$router.push({name: 'index'})
            },
            showLogin() {
              this.menuOpen = false
              this.$emit('displayLogin')
            }
        },
    }
</script>

<template lang="pug">
    .foo
        .debugContainer
          p uid: {{uid}}
          p isAuthenticated: {{isAuthenticated}}
          p isAdmin: {{isAdmin}}
          p isApproved: {{isApproved}}
          p userType: {{userType}}
          p
            a(href="/") Home
        .navContainer
            #img-header-lft.header-flex-item
                a.sbrc(href='https://www.sbrchamber.com/' target='_blank' rel='noreferrer noopener')
                    img.sbrc-img(src="@/assets/sbrc.png")
            #img-header.header-flex-item
                //- a(href='https://southbendelkhart.org/' target='_blank' rel='noreferrer noopener')
                router-link.logo-center(to='/' rel='noreferrer noopener')
                    img(src="@/assets/industry.connected_standard.png")
            #menu-container.header-flex-item
                close-icon.menu-icon( 
                  v-if="menuOpen" 
                  @click="menuOpen = !menuOpen" 
                )
                menu-icon.menu-icon( 
                  v-else 
                  @click="menuOpen = !menuOpen" 
                )

        .row.overlay-menu( v-if="menuOpen")
            #modal-list.menu-container
                a(v-if="!isAuthenticated" @click="showLogin" )
                    h6 LOG IN
                router-link#educ-link(to='/educator' v-if="userType == 'educator'")
                    h6 EDUCATOR PORTAL
                router-link#industry-link(to='/industry' v-if="userType == 'company'")
                    h6 INDUSTRY PORTAL
                router-link(to="/admin" v-if="isAdmin")
                    h6 ADMIN
                .col.s6.offset-s3
                    hr
                .col.s3
                .col.s12
                    a(href="/IndustyConnectEDEngagementOptions.pdf" target="_blank")
                        h6 OPPORTUNITIES TO CONNECT
                    a(href='https://www.sbrchamber.com/events/workforce/' target="_blank")
                            h6 EVENTS
                    router-link(to="/about")
                            h6 ABOUT
                .col.s6.offset-s3( v-if="isAuthenticated" )
                    hr(v-if="user!=null")      
                    a#logout-link(href='#' @click='logout')
                      h6 LOG OUT
                        

            
</template>

<style lang="sass" scoped>

.menu-container
  margin: 0 auto

.overlay-menu
  z-index: 4000
  text-align: center

a
  cursor: pointer

.debugContainer
  display: none
  p
    padding: 0px
    margin: 0px

a.logo-center
  height: 100%
  img
    margin: 0 auto

a.sbrc   
    padding-left: 10px;
    display: block;
    height: 100%;

.menu-icon
    cursor: pointer
    display: block;
    top: 25%;
    font-size: 3.5em
    margin: 0 auto   

.navContainer
    background-color: white
    height: 14vh
    width: 100vw
    position: relative
    display: flex
    justify-content: space-between
    padding-top: 5px
    padding-bottom: 5px
    align-content: center
    margin: 0 auto
    z-index: 1000
    div
        height: auto
        img
            display: block
            height: 100%
            position: relative
        
.header-flex-item
  width: 250px        

#img-header-lft  
    margin-left: 5px
    text-align: left
    img
      max-width: 100%

#img-header
    text-align: center

#menu-container
    margin-left: 5px

@media screen and ( max-width: 700px )    
  .sbrc-img          
    display: none !important

    


// MENU // 

#modal-list 
  padding-top: 5em;


#modal-list
    height: 100vh
    // position: fixed
    // z-index: 1001
    // background-color: white
    // width: 100vw
    h6 
        padding: .5em
        font-size: 22px
        text-align: center
        color: #808080
        font-weight: thick
        font-stretch: condensed


</style>